import { Theme } from "../../Theme"

export const LandingPageContainer = {};

export const LandingPageHeaderContainer = {
    width: "100%",
    backgroundColor: Theme.secondaryBody,
};

export const LandingPageVideoConatiner = {
    marginTop: "10px",
    marginBottom:"3em"
};
